export default __webpack_public_path__ + "static/media/funnel-plot.3470a265.svg";